import { render, staticRenderFns } from "./CreditNoteFormTab.vue?vue&type=template&id=327cb7a9&scoped=true"
import script from "./CreditNoteFormTab.vue?vue&type=script&lang=js"
export * from "./CreditNoteFormTab.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteFormTab.vue?vue&type=style&index=0&id=327cb7a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327cb7a9",
  null
  
)

export default component.exports